import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[75vh] grid place-items-center px-6" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white sticker rounded-3xl p-10 text-center max-w-md w-full">
        <XCircle size={64} weight="duotone" className="mx-auto text-brand-coral" />
        <h1 className="font-heading font-bold text-2xl text-ink mt-5">Checkout cancelled</h1>
        <p className="font-body text-ink-soft mt-2">No worries — your cart is still saved for you.</p>
        <Link to="/cart"><Button className="mt-6 w-full rounded-full bg-brand-sky hover:bg-brand-skylight text-white font-bold py-6 text-lg">Return to cart</Button></Link>
      </motion.div>
    </div>
  );
}
